import { usePredictionsContext } from '@src/providers/PredictionsProvider';
import { IconName, type FilterableProperty } from '@talos/kyoko';
import { useMemo } from 'react';

/**
 * Filter property for prediction-outcome event series.
 */
export function usePredictionSeriesFilter() {
  const { eventSeries, eventSeriesByID } = usePredictionsContext();

  return useMemo(
    () =>
      ({
        key: 'Series',
        label: 'Series',
        icon: IconName.CubeTransparent,
        control: 'multi-select',
        options: eventSeries.map(series => series.SeriesID),
        getOptionLabel: (option: string) => eventSeriesByID.get(option)?.SeriesName ?? option,
      }) as const satisfies FilterableProperty,
    [eventSeries, eventSeriesByID]
  );
}
